import { render, staticRenderFns } from "./App.vue?vue&type=template&id=939d423c&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939d423c",
  null
  
)

export default component.exports
import QSpinnerPie from 'quasar/src/components/spinner/QSpinnerPie.js';
import qInstall from "../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerPie});
